import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col justify-center items-center pb-2" }
const _hoisted_2 = { class: "tour-areas flex flex-wrap justify-center items-center gap-4" }
const _hoisted_3 = { class: "join" }
const _hoisted_4 = ["onClick", "data-tip"]
const _hoisted_5 = { class: "tour-areas join" }
const _hoisted_6 = ["onClick", "data-tip"]

import { computed, ref, watch } from "vue";
import {
  useHelpStore,
  CONFIG_AREAS,
  USER_AREAS,
  AREA_TOOLTIPS,
  AreaType,
} from "@/stores/help";
import KeysArea from "@/components/main/KeysArea.vue";
import LedsArea from "@/components/main/LedsArea.vue";
import MouseArea from "@/components/main/MouseArea.vue";
import GeneralArea from "@/components/main/GeneralArea.vue";
import KeycapsArea from "@/components/main/KeycapsArea.vue";
import DetectArea from "@/components/main/DetectArea.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainAreaSwitcher',
  setup(__props) {

const help = useHelpStore();

const components: Record<AreaType, unknown> = {
  keys: KeysArea,
  leds: LedsArea,
  mouse: MouseArea,
  general: GeneralArea,
  keycaps: KeycapsArea,
  detect: DetectArea,
};

const currentArea = ref<AreaType>("keys");
const resolvedArea = computed(() => help.selectedArea ?? currentArea.value);

watch(currentArea, (newArea) => {
  help.currentGuideArea = newArea;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CONFIG_AREAS), (area) => {
          return (_openBlock(), _createElementBlock("button", {
            key: area,
            onClick: ($event: any) => (currentArea.value = area),
            class: _normalizeClass(["btn btn-tooltip join-item", 
            resolvedArea.value == area ? 'btn-active btn-primary' : 'btn-neutral'
          ]),
            "data-tip": _unref(AREA_TOOLTIPS)[area]
          }, _toDisplayString(area), 11, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(USER_AREAS), (area) => {
          return (_openBlock(), _createElementBlock("button", {
            key: area,
            onClick: ($event: any) => (currentArea.value = area),
            class: _normalizeClass(["btn btn-tooltip join-item", 
            resolvedArea.value == area ? 'btn-active btn-primary' : 'btn-neutral'
          ]),
            "data-tip": _unref(AREA_TOOLTIPS)[area]
          }, _toDisplayString(area), 11, _hoisted_6))
        }), 128))
      ])
    ]),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(components[resolvedArea.value])))
    ], 1024))
  ]))
}
}

})